import { Box, spacing } from "@procore/core-react";

import { SlottedWindow } from "components/window/SlottedWindow";
import type { BaseWindowProps } from "contexts/windows/reducer";

import { BrepSection } from "./brepSection";
import { FindSection } from "./findSection";
import { LinksSection } from "./linksSection";
import { OfflineSection } from "./offlineSection";
import { SceneSection } from "./sceneSection";
import { SelectedObjectSection, SelectionSection } from "./selectedObjectSection";
import { useProcoreOrigin } from "./useProcoreOrigin";
import { ViewSection } from "./viewSection";

export function DebugUtilsWindow({ onClose, position }: BaseWindowProps) {
    const procoreOrigin = useProcoreOrigin();

    return (
        <SlottedWindow
            position={position}
            size={{ width: 400 }}
            autoHeight
            onClose={onClose}
            headerRegion={<SlottedWindow.Title>Debug utils</SlottedWindow.Title>}
            data-testid="debug-utils-window"
        >
            <Box style={{ display: "flex", flexDirection: "column", gap: spacing.lg, padding: spacing.lg }}>
                <LinksSection procoreOrigin={procoreOrigin} />
                <SceneSection procoreOrigin={procoreOrigin} />
                <ViewSection />
                <FindSection />
                <SelectedObjectSection />
                <SelectionSection />
                <BrepSection />
                <OfflineSection />
            </Box>
        </SlottedWindow>
    );
}
